module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Topmatter content"
  }, [_c('div', {
    staticClass: "listcon"
  }, [_c('div', {
    staticClass: "listname"
  }, [_vm._v("申请公租房一件事")]), _vm._v(" "), _c('div', {
    staticClass: "listbutton"
  }, [_c('a', {
    staticClass: "reservation",
    attrs: {
      "href": "https://www.gdzwfw.gov.cn/portal/v3/guide-combo/11440106MB2D2880XN444TC140BB001",
      "target": "_blank"
    }
  }, [_vm._v("在线预约")]), _vm._v(" "), _c('a', {
    staticClass: "guide",
    on: {
      "click": function($event) {
        return _vm.openWechat('https://www.gdzwfw.gov.cn/portal/v3/guide-combo/11440106MB2D2880XN444TC140BB001')
      }
    }
  }, [_vm._v("办事指南")])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#FAFAFB"
    }
  }, [_c('div', {
    staticClass: "Bsjd content",
    attrs: {
      "id": "bsjd"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "left-right"
  }, [_c('div', {
    staticClass: "bsjdMain"
  }, [_c('div', {
    staticClass: "swiper img-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/yytx26.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://mp.weixin.qq.com/s/wkniV0f4oZvuuQGIFfTiPQ')
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "go-detail",
    attrs: {
      "src": require("../../static/img/details/godetail.gif")
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://mp.weixin.qq.com/s/wkniV0f4oZvuuQGIFfTiPQ')
      }
    }
  })])])])]), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "Znyd content",
    attrs: {
      "id": "znyd"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "znydMain"
  }, [_c('div', {
    staticClass: "yd-qx"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.daoBanList), function(item1, index1) {
    return _c('div', {
      staticClass: "yd-qx-list"
    }, [_c('div', {
      staticClass: "guide-icon guide-icon-active"
    }), _vm._v(" "), (index1) ? _c('div', {
      staticClass: "guide-line-top"
    }) : _c('div', {
      staticClass: "guide-line-bottom"
    }), _vm._v(" "), _c('div', {
      staticClass: "qx-rom"
    }, [_c('div', {
      staticClass: "romtit"
    }, [_vm._v(_vm._s(item1.title))]), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, _vm._l((item1.values), function(item2, index2) {
      return _c('div', {
        class: item2.xuanzhong ? "btn1 active1" : "btn1",
        on: {
          "click": function($event) {
            return _vm.daobanItemChoose(index1, index2)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(item2.name) + "\n                ")])
    }), 0)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "right-cl"
  }, [_c('div', {
    staticClass: "clMain"
  }, [_c('div', {
    staticClass: "cltitle"
  }, [_vm._v("需要提供的材料")]), _vm._v(" "), _c('div', {
    staticClass: "cltable"
  }, [_vm._m(6), _vm._v(" "), _c('ul', _vm._l((_vm.cailiaoList), function(item, index) {
    return _c('li', [_c('div', {
      staticClass: "clname"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "clzt"
    }, [_vm._v(_vm._s(item.state))])])
  }), 0)])])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "Frequency",
    attrs: {
      "id": "gpsx"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "freMain"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise2')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon1.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("内资有限责任公司设立登记")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise3')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon1.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("内资有限责任公司变更登记")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailEnterprise5')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon2.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("企业注册登记档案查询")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate2')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon3.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("公共场所卫生许可（新证，含改、扩建)")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.openWechat('https://thzwb.thnet.gov.cn/yytx/#/SearchDetailOperate4')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/gp-icon2.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("公众聚集场所投入使用、营业前消防安全检查（告知承诺件）")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "Leftnav"
  }, [_c('ul', [_c('li', {
    class: [_vm.isInArea1 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(1)
      }
    }
  }, [_c('a', [_vm._v("路标式解读")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea2 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(2)
      }
    }
  }, [_c('a', [_vm._v("场景式导办")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea3 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(3)
      }
    }
  }, [_c('a', [_vm._v("地图导航")])]), _vm._v(" "), _c('li', {
    class: [_vm.isInArea4 ? 'Lactive' : ''],
    on: {
      "click": function($event) {
        return _vm.scrollToArea(4)
      }
    }
  }, [_c('a', [_vm._v("高频事项")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-header"
  }, [_c('div', {
    staticClass: "header-main content"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": require("../../static/img/index/headtitle.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("“路标式”政务服务事项解读体系")]), _vm._v(" "), _c('img', {
    staticClass: "gzjz",
    attrs: {
      "src": require("../../static/img/index/gzjz.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ewm"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/QRcode/yytx26.png")
    }
  }), _vm._v(" "), _c('div', [_vm._v("使用微信扫码登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conTitle detailConTitle1"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-lbsjd.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bsjd-table"
  }, [_c('div', {
    staticClass: "bsjd-body"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("文件依据")]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item"
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gov.cn/gongbao/content/2012/content_2226147.htm"
    }
  }, [_vm._v("公共租赁住房管理办法")])]), _vm._v(" "), _c('div', [_vm._v("2016-12-13")])]), _vm._v(" "), _c('div', {
    staticClass: "bsjd-item"
  }, [_c('div', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gz.gov.cn/gfxwj/szfgfxwj/gzsrmzfbgt/content/post_9795843.html"
    }
  }, [_vm._v("广州市人民政府办公厅关于印发广州市公共租赁住房管理办法的通知")])]), _vm._v(" "), _c('div', [_vm._v("2024-02-19")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-cjsdb.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-h",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "image-c"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/intelligent/robort.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("选择办事情形")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tablehead"
  }, [_c('span', {
    staticClass: "clname"
  }, [_vm._v("申请材料名称")]), _vm._v(" "), _c('span', {
    staticClass: "clzt"
  }, [_vm._v("材料要求")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content hall",
    attrs: {
      "id": "dtdh"
    }
  }, [_c('div', {
    staticClass: "conTitle detailConTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle-dtdh.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mapContanier",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "24px"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://thzwb.thnet.gov.cn/icity_pc/#/index",
      "frameborder": "0",
      "width": "100%",
      "height": "1000"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conTitle"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/details/detailTitle5.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d87a19c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SearchDetailHouse9.vue
// module id = 1126
// module chunks = 0